import { Loader } from '@/components/shared';
import type { IUser } from '@/types';
import { getCaptchaToken, pathJoin } from '@/utils';
import { Box, Container, Flex, Tab, TabList, TabPanel, TabPanels, Tabs } from '@chakra-ui/react';
import { useTranslation } from 'react-i18next';
import { CompanySignUpForm, PersonSignUpForm } from '../components';
import { PlainLayout } from '../layout';
import { apiUrl as baseApiUrl } from '@/config';
import { Suspense } from 'react';
import { useNavigate, createSearchParams } from 'react-router-dom';
import { ROUTE_PATHS } from '@/constants';
import { Section } from '../components/Section';

export const FullSignup = (): JSX.Element => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  const handleSignupFormSubmit = async (userInfo: IUser): Promise<void> => {
    if (baseApiUrl) {
      const token = await getCaptchaToken();

      const response = await fetch(`${baseApiUrl}/customer/register`, {
        method: 'POST',
        headers: {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'content-type': 'application/json',
          // eslint-disable-next-line @typescript-eslint/naming-convention
          'X-Recaptcha-Token': token,
        },
        body: JSON.stringify(userInfo),
      });

      if (!response.ok) {
        throw new Error('failed');
      } else {
        navigate({
          pathname: pathJoin([`/${ROUTE_PATHS.quote}`, ROUTE_PATHS.checkEmailMessage]),
          search: createSearchParams({
            name: userInfo.email,
          }).toString(),
        });
      }
    }
  };

  return (
    <PlainLayout>
      <Suspense fallback={<Loader />}>
        <Box bg="brand.sand" px={{ base: '15px', md: 0 }} py={16} w="full">
          <Container bg="white" minW="75%" px={{ base: '5', md: '20%' }} py="5%">
            <Flex alignItems="center" direction="column">
              <Section
                containerProps={{ px: 0, py: 0 }}
                headingProps={{ mt: 0 }}
                id="login-form"
                title={t('SIGNUP.SIGNUP_TITLE')}
              >
                <Tabs flexGrow={1} isLazy variant="mbe">
                  <TabList gap={8}>
                    <Tab>{t('SIGNUP.FORM.PERSON')}</Tab>
                    <Tab>{t('SIGNUP.FORM.COMPANY')}</Tab>
                  </TabList>
                  <TabPanels>
                    <TabPanel pt={8} px={0}>
                      <PersonSignUpForm
                        isFullSignup={true}
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onSubmit={handleSignupFormSubmit}
                      />
                    </TabPanel>
                    <TabPanel pt={8} px={0}>
                      <CompanySignUpForm
                        isFullSignup={true}
                        // eslint-disable-next-line @typescript-eslint/no-misused-promises
                        onSubmit={handleSignupFormSubmit}
                      />
                    </TabPanel>
                  </TabPanels>
                </Tabs>
              </Section>
            </Flex>
          </Container>
        </Box>
      </Suspense>
    </PlainLayout>
  );
};
